<script setup>
import EmployeeTable from "./Tables/EmployeeTable.vue";
// import ArgonButton from "@/components/ArgonButton.vue";

</script>
<template>
    <div class="py-4 container-fluid ">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header pb-0">
                <h6>Employee Info</h6>
                </div>
                <div class="py-4 container-fluid">
                    <div class="row ">
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Name</label>
                            <input class="form-control" v-model="model.employee.name" id="input_name" type="text" placeholder="Ang Wei Ze" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Contact</label>
                            <input class="form-control" v-model="model.employee.contact" id="input_contact" type="text" placeholder="Contact" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">IC</label>
                            <input class="form-control" v-model="model.employee.ic" id="input_ic" type="text" placeholder="IC/Passport" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Race</label>
                            <select class="form-control" v-model="model.employee.race" id="input_race">
                                <option value="0">Malay</option>
                                <option value="1">Chinese</option>
                                <option value="2">Indian</option>
                                <option value="3">Indo</option>
                                <option value="4">Myamar</option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Basic (RM/Hour)</label>
                            <input class="form-control" v-model="model.employee.basic" id="input_ic" type="number" placeholder="" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Basic Luar (RM/Hour)</label>
                            <input class="form-control" v-model="model.employee.basic_luar" id="input_ic" type="number" placeholder="" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Basic Racun (RM/Hour)</label>
                            <input class="form-control" v-model="model.employee.basic_racun" id="input_ic" type="number" placeholder="" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">OT (RM/Hour)</label>
                            <input class="form-control" v-model="model.employee.ot" id="input_ic" type="number" placeholder="" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">OT Luar (RM/Hour)</label>
                            <input class="form-control" v-model="model.employee.ot_luar" id="input_ic" type="number" placeholder="" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">OT Racun (RM/Hour)</label>
                            <input class="form-control" v-model="model.employee.ot_racun" id="input_ic" type="number" placeholder="" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Socso (%)</label>
                            <input class="form-control" v-model="model.employee.socso" id="input_ic" type="number" placeholder="" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">EPF (%)</label>
                            <input class="form-control" v-model="model.employee.epf" id="input_ic" type="number" placeholder="" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <button class="btn btn-success "  @click="addEmployee" style="float: right;" id="btn_add">Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="mt-4 row">
        <div class="col-12">
            <EmployeeTable :key="componentKey"/>
        </div>
    </div>
    </div>
</template>


<script>
import axios from 'axios';

export default {
  name:'employeeCreate',
  data(){
    return {
        componentKey: 0,
    //   errorList: '',
      model:{
        employee:{
            name:'',
            ic:'',
            contact:'',
            race:0,
            basic:0.00,
            basic_luar:0.00,
            basic_racun:0.00,
            ot:0.00,
            ot_luar:0.00,
            ot_racun:0.00,
            epf:0.00,
            socso:0.00,
        }
        

      }
    }
  },
  methods: {

    addEmployee(){
        // var mythis = this;
        axios.post('payroll/addEmployee',this.model.employee)
            .then(res => {
                alert(res.data.message);
                this.model.employee = {
                    name:'',
                    ic:'',
                    contact:'',
                    race:0,
                    basic:0.00,
                    basic_luar:0.00,
                    basic_racun:0.00,
                    ot:0.00,
                    ot_luar:0.00,
                    ot_racun:0.00,
                    epf:0.00,
                    socso:0.00,
                };
                this.componentKey += 1;
                
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Name, Race, Contact, Basic and OT is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    }
  },
}
</script>